import api from "../api";
import {subscribeToChannel, unsubscribeToChannel} from "../services/pusher";
import store from "../store";

const state = () => ({
  filters: {
    activePipelineView: {
      id: null
    }
  },

  // The UI should only Use These Counts if there is an Active Pipeline View Selected, Otherwise it should use the counts in the Account Store.
  /**
   * Server Side Reactive
   */
  pipelineViewCounts: {
    contacting_count: 0,
    active_count: 0,
    follow_up_count: 0,
    completed_count: 0,
    dead_count: 0,
    non_lead_count: 0,
  },
});

const getters = {
  pipelineViewCounts(state, getters, rootState, rootGetters) {
    return state.pipelineViewCounts;
  },
  activePipelineView(state, getters, rootState, rootGetters) {
    return rootState.account.pipelineViews.find(pipelineView => pipelineView.id === state.filters.activePipelineView.id);
  },
};

const mutations = {
  setup(state, data) {
    state.pipelineViewCounts = data.pipelineViewCounts;
  },
  setActivePipelineViewId(state, activePipelineViewId) {
    // This should only be called form the action
    state.filters.activePipelineView.id = activePipelineViewId
    store.dispatch('updateUserAppFilter')
  },
  setOneFilter(state, [filterName, filter, value]) {
    state.filters[filterName][filter] = value;
    store.dispatch('updateUserAppFilter')
  },
  setUserFilters(state, filters) {
    // make sure this match the filters declared on state
    state.filters = filters
  },
};

const actions = {
  setup({dispatch, commit, state, rootState, getters}, pipelineViewId) {
    // Make sure you can subscribe to more then one at a time
    if (state.filters.activePipelineView.id !== pipelineViewId) {
      unsubscribeToChannel("activePipelineView", state.filters.activePipelineView.id);
    }

    // Make sure we dont try to resubscribe if the pipeline view id is falsy
    if (!pipelineViewId) {
      commit('setActivePipelineViewId', null);
      // trigger to reload active pipeline if the value changes
      store.commit("activeState/setPipelineViewId", null);
      return;
    }

    subscribeToChannel("activePipelineView", pipelineViewId);

    return api.clientStore.initActivePipelineView(pipelineViewId).then(response => {
      commit('setActivePipelineViewId', pipelineViewId);
      commit('setup', response.data);
      // trigger to reload active pipeline if the value changes
      store.commit("activeState/setPipelineViewId", pipelineViewId);
    }).catch(() => {
      commit('setActivePipelineViewId', null);
    });
  },
  tearDown({commit, state, rootState, getters}) {
    unsubscribeToChannel("activePipelineView", state.filters.activePipelineView.id);
  },
};

const ActivePipelineViewStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default ActivePipelineViewStore;
